import dayjs from "dayjs";
import "dayjs/locale/pl";
import CustomParseFormat from "dayjs/plugin/customParseFormat";
import IsoWeek from "dayjs/plugin/isoWeek";
import UTC from "dayjs/plugin/utc";

dayjs.extend(CustomParseFormat);
dayjs.extend(IsoWeek);
dayjs.extend(UTC);
export const LOCALE = "pl";
dayjs.locale(LOCALE);

export default dayjs;

export const ISO_DATE_FORMAT = "YYYY-MM-DD";
export const DATE_FORMAT = "DD-MM-YYYY";
